import { DateTime } from 'luxon';
import { Enum } from './enum';

export namespace Calendar {
  export enum Unit {
    DAYS = 'days',
    WEEKS = 'weeks',
    MONTHS = 'months'
  }

  export namespace Unit {
    export const normalize = (value: unknown): Unit | undefined => Enum.normalize(Unit, value);
  }

  export enum Weekday {
    SUNDAY = 'Sunday',
    MONDAY = 'Monday',
    TUESDAY = 'Tuesday',
    WEDNESDAY = 'Wednesday',
    THURSDAY = 'Thursday',
    FRIDAY = 'Friday',
    SATURDAY = 'Saturday'
  }

  export const WeekdayOrdinalMap = ['First', 'Second', 'Third', 'Fourth', 'Fifth'];

  export const getMonthlyWeekdayDescriptor = (date: DateTime): {
    type: 'LAST' | 'NTH';
    nth: number;
    ordinal: string;
    weekday: string;
    weekdayNumber: number;
  } => {

    const {weekday} = date; // 1 (Mon) → 7 (Sun)
    const dayOfMonth = date.day;

    const ordinalMap = ['First', 'Second', 'Third', 'Fourth', 'Fifth'];

    const weekdayMap = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday'
    ];

    const nth = Math.ceil(dayOfMonth / 7);

    // Check if another same weekday exists later in the month
    const nextSameWeekday = date.plus({ weeks: 1 });

    const isLast =
      nextSameWeekday.month !== date.month;

    return {
      type: isLast ? 'LAST' : 'NTH',
      nth,
      ordinal: isLast ? 'Last' : ordinalMap[nth - 1],
      weekday: weekdayMap[weekday - 1],
      weekdayNumber: weekday
    };
  };

  export namespace Weekday {
    export const normalize = (value: unknown): Weekday | undefined =>
      Enum.normalize(Weekday, value);
  }
}
